import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

/**
 * Hyperlink für die Navigation innerhalb der Anwendung
 *
 * @param to Ziel-URL innerhalb der Anwendung
 * @param children der darzustellende Text (kann auch HTML sein)
 * @param rest weitere Parameter
 * @returns {JSX.Element}
 * @constructor
 */
function EANavButton({ to, children, ...rest }) {
    return (
        <Link to={to} {...rest}>
            {children}
        </Link>
    );
}

EANavButton.propTypes = {
    to: PropTypes.any.isRequired,
    children: PropTypes.any,
};

export default EANavButton;
